import { GET_CHATMSGS } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_CHATMSGS:
            return action.payload;
        default:
            return state;
    }
}